import {
  goToForm,
  goToPage,
  goToUrl,
  goToModal,
  getData,
  postData,
  putData,
  deleteData,
  createAndUpdate,
  updateStatus,
  moveUpDown,
} from '../Action'

export const doOptionalAction = (menu, dataSelected, propTable) => {
  const {
    history,
    designContext,
    historyContext,
    allParams,
    uischema,
    genRefId,
    columnRefId,
    propAction,
    onAction,
  } = propTable

  const { setModalAction, renderTableData, onRowTableUpdate } = onAction

  switch (menu.action) {
    case 'goToForm':
      return goToForm(
        menu,
        history,
        dataSelected,
        designContext,
        historyContext,
      )
    case 'goToPage':
      return goToPage(
        menu,
        history,
        dataSelected,
        designContext,
        historyContext,
      )
    case 'goToUrl':
      return goToUrl(menu, uischema, dataSelected, designContext)
    case 'openModal':
      setModalAction(menu)
      return goToModal(
        menu,
        menu?.modal?.key,
        dataSelected,
        designContext,
        uischema,
      )
    case 'getData':
      return getData({
        action: menu,
        rowData: dataSelected,
        designContext,
        renderTableData,
        allParams,
      })
    case 'postData':
      return postData({
        action: menu,
        rowData: dataSelected,
        designContext,
        renderTableData,
        allParams,
      })
    case 'putData':
      return putData({
        action: menu,
        rowData: dataSelected,
        designContext,
        renderTableData,
        allParams,
      })
    case 'deleteData':
      return deleteData({
        action: menu,
        rowData: dataSelected,
        designContext,
        renderTableData,
        allParams,
      })
    case 'createAndUpdate':
      return createAndUpdate({
        action: menu,
        rowData: dataSelected,
        designContext,
        renderTableData,
        allParams,
      })
    case 'updateStatus':
      return updateStatus(
        menu,
        dataSelected,
        onRowTableUpdate,
        genRefId,
        columnRefId,
        propAction,
      )
    case 'moveUp':
      return moveUpDown('UP', dataSelected, propAction)
    case 'moveDown':
      return moveUpDown('DOWN', dataSelected, propAction)
    default:
      return console.log(menu.action, dataSelected)
  }
}
